import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import LogRocket from 'logrocket'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userData: null,

    // App wide settings, shared by every user. Kept in sync with the appSettings/global
    // firestore doc by the listener in main.js.
    appSettings: {
      disableSixHourDelay: false,
    },
  },
  mutations: {
    setUserData(state, data) {
      state.userData = data

      LogRocket.identify(data.uid, {
        name: data.name,
        email: data.email,
        // Add your own custom user variables here, ie:
        // subscriptionType: 'pro'
      })
    },
    setAppSettings(state, data) {
      // Merge so a setting missing from the firestore doc falls back to its default.
      state.appSettings = { ...state.appSettings, ...data }
    },
  },
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
  },
})
